// Action constants
export var BACK = 'Navigation/BACK';
export var INIT = 'Navigation/INIT';
export var NAVIGATE = 'Navigation/NAVIGATE';
export var SET_PARAMS = 'Navigation/SET_PARAMS'; // Action creators

export var back = function back() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: BACK,
    key: payload.key,
    immediate: payload.immediate
  };
};
export var init = function init() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = {
    type: INIT
  };
  if (payload.params) {
    action.params = payload.params;
  }
  return action;
};
export var navigate = function navigate(payload) {
  var action = {
    type: NAVIGATE,
    routeName: payload.routeName
  };
  if (payload.params) {
    action.params = payload.params;
  }
  if (payload.action) {
    action.action = payload.action;
  }
  if (payload.key) {
    action.key = payload.key;
  }
  return action;
};
export var setParams = function setParams(payload) {
  return {
    type: SET_PARAMS,
    key: payload.key,
    params: payload.params,
    preserveFocus: true
  };
};